import { load } from 'webfontloader';

export const loadTypekitFonts = async (id: string) => {
  return new Promise<void>((resolve, reject) => {
    load({
      typekit: { id },
      active: resolve,
      inactive: reject,
    });
  });
};
